import map from "lodash/map";
import { v4 as uuid } from "uuid";
function serializeSingleEdge(edge) {
    var _a;
    const edgeData = {
        Id: (_a = edge.tag.EdgeId) !== null && _a !== void 0 ? _a : uuid(),
        Source: edge.tag.From,
        Target: edge.tag.To,
        Bends: [],
        SourcePort: null,
        TargetPort: null
    };
    if (edge.sourcePort) {
        edgeData.SourcePort = {
            Name: "null",
            FreeNodePortLocationModelParameterRatio: 0,
            X: 0,
            Y: 0
        };
    }
    if (edge.targetPort) {
        edgeData.TargetPort = {
            Name: "null",
            FreeNodePortLocationModelParameterRatio: 0,
            X: 0,
            Y: 0
        };
    }
    return edgeData;
}
export function serializeEdges(graph) {
    return map(graph.edges.toArray(), (edge) => serializeSingleEdge(edge));
}
